var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app header-fixed sidebar-fixed aside-menu-fixed sidebar-lg-show pace-done"},[_c('header-partial'),_c('div',{staticClass:"app-body"},[_c('sidebar-partial'),_c('main',{staticClass:"main"},[_c('breadcrumb-partial',{attrs:{"routes":_vm.list}}),_c('div',{staticClass:"container-fluid p-0 m-0"},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }